import React, { createContext, useState } from "react";

export const GerenciarPedidoContext = createContext({});

export const gerenciarPedidosProvider = ({ children }) => {
    let [filters] = useState({});
    return (
        <GerenciarPedidoContext.Provider value={{ filters }}>
            {children}
        </GerenciarPedidoContext.Provider>
    );
};
